import { Box, CardMedia, Icon, Modal, Skeleton, Typography } from '@mui/material'
import useOpenClose from 'services/hooks/useOpenClose'
import Tags from './Tags'
import EditDetailsModal from '../../recruitment-external-talent/components/EditDetailsModal'
import { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  getRequestVideoInterview,
  postRequestVideoInterview,
  updateCandidate,
} from 'services/api/modules/recruitment/external-talent'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import AdxButton from 'components/custom/AdxButton'

// card for vided and cv
const LockCard = ({
  word,
  icon,
  unlocked,
  handleClick,
  profileType,
  hasVideoRequested,
  handleRequestVideo,
  isLoading,
  hasVideo,
  hasCV,
  disabled,
}) => {
  return (
    <Box display="flex" flexDirection="column">
      <Box
        display="flex"
        sx={{
          width: '98%',
          border: '1px solid',
          borderRadius: '0',
          borderColor: 'gray-line.main',
        }}
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center" columnGap={2}>
          <Box
            marginLeft={2}
            width={'35px'}
            height={'35px'}
            borderRadius="50%"
            bgcolor="gray-background.main"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Icon sx={{ color: 'alternate.main' }}>{icon}</Icon>
          </Box>
          <Typography
            marginLeft={5}
            variant="subtitle1"
            color="dark-text.main"
            paddingY={3}
            align="center"
            fontWeight="bold"
          >
            {word}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" marginRight={2}>
          {unlocked && !hasVideo && profileType === 'jobseeker' && word === 'Video interview' ? (
            <AdxButton
              variant={'contained'}
              isLoading={isLoading}
              size="small"
              sx={{ width: '150px' }}
              onClick={handleRequestVideo}
            >
              {hasVideoRequested == null ? 'Request' : 'Requested'}
            </AdxButton>
          ) : unlocked ? (
            <AdxButton
              variant={'contained'}
              disabled={disabled}
              size="small"
              sx={{ width: '150px' }}
              onClick={handleClick}
            >
              View
            </AdxButton>
          ) : (
            <Tags
              typo="subtitle1"
              icon="lock"
              sxIcon={{ fontSize: '20px' }}
              word="Purchase to view"
              sx={{ padding: '15px', borderRadius: '5px' }}
            />
          )}
          {/* {unlocked ? (
            <AdxButton size="small" sx={{ width: '150px' }} onClick={handleClick}>
              View
            </AdxButton>
          ) : (
            <Tags
              typo="subtitle1"
              icon="lock"
              sxIcon={{ fontSize: '20px' }}
              word="Purchase to view"
              sx={{ padding: '15px', borderRadius: '5px' }}
            />
          )} */}
        </Box>
      </Box>
    </Box>
  )
}
// text tag for skills
const Skills = ({ word }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      bgcolor="gray-background.main"
      sx={{
        borderRadius: '6px',
      }}
    >
      <Typography variant="subtitle1" color="dark-text.main" padding={1} align="center">
        {word}
      </Typography>
    </Box>
  )
}

const PersonalDrawer = ({
  name,
  skills,
  email,
  contactNumber,
  unlocked,
  has_video,
  isLoading,
  error,
  cv,
  videoURL,
  candidate_id,
  profile_type,
}) => {
  const hasCV = cv?.includes('https')

  //state for edit detail modal
  const queryClient = useQueryClient()

  const [open, setOpen] = useState(false)
  const defaultValues = {
    name: name ? name : '',
    email: email ? email : '',
    contact: contactNumber ? contactNumber : '',
  }
  const [talentDetails, setTalentDetails] = useState(defaultValues)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
    setTalentDetails({
      name: name ? name : '',
      email: email ? email : '',
      phone: contactNumber ? contactNumber : '',
    })
  }

  // api to edit detail
  const { mutate: editDetails, error: updateError } = useMutation(
    (data) => updateCandidate(candidate_id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('getCandidate')
        queryClient.invalidateQueries('getAllCandidate')
        queryClient.invalidateQueries('getAllApplicant')
        queryClient.invalidateQueries('getApplicantDetail')
        setOpen(false)
      },
      onError: (error) => {
        console.error(error)
      },
    }
  )

  const { data: requestVideoInterviewData, isLoading: requestVideoInterviewIsLoading } = useQuery(
    ['getRequestVideoInterview', candidate_id],
    async () => {
      if (candidate_id && profile_type === 'jobseeker') {
        const { data } = await getRequestVideoInterview(candidate_id)
        return data
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const {
    mutate: mutateRequestVideoInterview,
    error: mutateRequestVideoInterviewError,
    isLoading: mutateIsLoading,
  } = useMutation((data) => postRequestVideoInterview(candidate_id, data), {
    onSuccess: () => {
      queryClient.invalidateQueries('getRequestVideoInterview')
    },
    onError: (error) => {
      console.error(error)
    },
  })

  // modal for video dialog
  const videoDialogHandle = useOpenClose()

  //split skill which is a string into an array
  const arraySkill = skills?.split(',') ?? null

  // video modal component
  const VideoModal = () => {
    const style = {
      position: 'relative',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '640px',
      width: '100%',
      bgcolor: 'black',
      height: '480px',
    }
    return (
      <Modal onClose={videoDialogHandle.handleClose} open={videoDialogHandle.isOpen}>
        <Box display="flex" alignItems="center" justifyContent="center" sx={style}>
          <Box
            position="absolute"
            zIndex={3475}
            onClick={videoDialogHandle.handleClose}
            sx={{
              right: 0,
              top: 0,
            }}
          >
            <Icon sx={{ color: 'white.main', cursor: 'pointer' }}>close_icon</Icon>
          </Box>
          <CardMedia
            sx={{
              objectFit: 'contain',
              height: '100%',
              width: '100%',
            }}
            component="video"
            controls
            src={videoURL !== undefined ? videoURL : null}
          />
        </Box>
      </Modal>
    )
  }

  if (isLoading) {
    return (
      <Box paddingTop={2} paddingX={2}>
        <Skeleton variant="rectangular" width={'100%'} height={60} />

        <Box>
          <Typography
            textAlign="left "
            variant="subtitle1"
            color="dark-text.main"
            marginTop={3}
            marginBottom={2}
            align="center"
            fontWeight="bold"
          >
            <Skeleton variant="text" width={'30%'} />
          </Typography>
          <Box display="flex" columnGap={4}>
            <Typography
              textAlign="left "
              variant="body1"
              color="light-gray-text.main"
              align="center"
              marginBottom={2}
              width={120}
            >
              <Skeleton variant="text" width={'80%'} />
            </Typography>
            <Typography textAlign="left " variant="body1" color="dark-text.main" align="center">
              <Skeleton variant="text" width={120} />
            </Typography>
          </Box>
          <Box display="flex" columnGap={4}>
            <Typography
              textAlign="left "
              variant="body1"
              color="light-gray-text.main"
              align="center"
              width={120}
            >
              <Skeleton variant="text" width={'80%'} />
            </Typography>
            <Typography textAlign="left " variant="body1" color="dark-text.main" align="center">
              <Skeleton variant="text" width={120} />
            </Typography>
          </Box>
        </Box>
        <Box marginTop={4}>
          <Typography
            textAlign="left "
            variant="subtitle1"
            color="dark-text.main"
            paddingY={3}
            align="center"
            fontWeight="bold"
          >
            <Skeleton variant="text" width={'30%'} />
          </Typography>
          <Skeleton variant="rounded" width={'100%'} height={50} />
        </Box>
      </Box>
    )
  } else if (error !== null) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          height: 200,
          overflow: 'hidden',
        }}
      >
        <AdxEmptyStateV2
          icon={<Icon>person_alert</Icon>}
          title="No personal records found"
          subtitle={null}
        />
      </Box>
    )
  } else {
    return (
      <>
        <Box paddingTop={2} paddingX={2}>
          {unlocked ? (
            <Box>
              {cv && (
                <LockCard
                  profileType={profile_type}
                  unlocked={true}
                  word="Resume"
                  icon="article"
                  handleClick={hasCV ? () => window.open(cv) : () => {}}
                  hasCV={hasCV}
                  disabled={!hasCV}
                />
              )}
              {profile_type === 'jobseeker' && (
                <LockCard
                  handleRequestVideo={() => mutateRequestVideoInterview(candidate_id)}
                  hasVideoRequested={requestVideoInterviewData}
                  isLoading={mutateIsLoading}
                  profileType={profile_type}
                  unlocked={true}
                  word="Video interview"
                  icon="video_file"
                  handleClick={videoDialogHandle.handleOpen}
                  hasVideo={has_video}
                  disabled={!has_video}
                />
              )}
            </Box>
          ) : (
            <Box>
              <LockCard profileType={profile_type} unlocked={false} word="Resume" icon="article" />
              {has_video && (
                <LockCard
                  profileType={profile_type}
                  unlocked={false}
                  word="Video interview"
                  icon="video_file"
                />
              )}
            </Box>
          )}

          <Box>
            <Typography
              textAlign="left "
              variant="subtitle1"
              color="dark-text.main"
              marginTop={3}
              marginBottom={2}
              align="center"
              fontWeight="bold"
            >
              Contact details
            </Typography>
            <Box display="flex" columnGap={4}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                marginBottom={2}
                width={120}
              >
                Email
              </Typography>
              <Typography textAlign="left " variant="body1" color="dark-text.main" align="center">
                {unlocked ? (
                  email ? (
                    profile_type === 'resume' ? (
                      <Box
                        onClick={handleToggle}
                        sx={{
                          color: 'transparent',
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                          cursor: 'pointer',
                          '&:hover': { color: 'alternate.main' },
                        }}
                      >
                        <Typography
                          sx={{ color: 'dark-text.main', '&:hover': { color: 'alternate.main' } }}
                        >
                          {email}
                        </Typography>
                        <Icon sx={{ fontSize: '16px' }}>edit</Icon>
                      </Box>
                    ) : (
                      email
                    )
                  ) : (
                    <Box
                      onClick={handleToggle}
                      sx={{
                        width: 'fit-content',
                        color: 'alternate.main',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1px',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                    >
                      <Icon sx={{ fontSize: '16px' }}>add</Icon>
                      <Typography>Add</Typography>
                    </Box>
                  )
                ) : (
                  <>
                    <Typography
                      display="flex"
                      alignItems="center"
                      variant="body1"
                      color="light-gray-text.main"
                      align="left"
                      marginBottom={2}
                    >
                      <Icon sx={{ color: 'alternate.main', fontSize: '20px' }}>lock</Icon>
                      Purchase to view
                    </Typography>
                  </>
                )}
              </Typography>
            </Box>
            <Box display="flex" columnGap={4}>
              <Typography
                textAlign="left "
                variant="body1"
                color="light-gray-text.main"
                align="center"
                width={120}
              >
                Contact number
              </Typography>
              <Typography textAlign="left " variant="body1" color="dark-text.main" align="center">
                {unlocked ? (
                  contactNumber ? (
                    profile_type === 'resume' ? (
                      <Box
                        onClick={handleToggle}
                        sx={{
                          color: 'transparent',
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                          cursor: 'pointer',
                          '&:hover': { color: 'alternate.main' },
                        }}
                      >
                        <Typography
                          sx={{ color: 'dark-text.main', '&:hover': { color: 'alternate.main' } }}
                        >
                          {contactNumber}
                        </Typography>
                        <Icon sx={{ fontSize: '16px' }}>edit</Icon>
                      </Box>
                    ) : (
                      contactNumber
                    )
                  ) : (
                    <Box
                      onClick={handleToggle}
                      sx={{
                        width: 'fit-content',
                        color: 'alternate.main',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1px',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                    >
                      <Icon sx={{ fontSize: '16px' }}>add</Icon>
                      <Typography>Add</Typography>
                    </Box>
                  )
                ) : (
                  <>
                    <Typography
                      display="flex"
                      alignItems="center"
                      variant="body1"
                      color="light-gray-text.main"
                      align="left"
                      marginBottom={2}
                    >
                      <Icon sx={{ color: 'alternate.main', fontSize: '20px' }}>lock</Icon>
                      Purchase to view
                    </Typography>
                  </>
                )}
              </Typography>
            </Box>
          </Box>
          <Box marginTop={4}>
            <Typography
              textAlign="left "
              variant="subtitle1"
              color="dark-text.main"
              paddingY={3}
              align="center"
              fontWeight="bold"
            >
              Skills
            </Typography>
            <Box display="flex" columnGap={2} rowGap={2} flexWrap="wrap" alignItems="center">
              {arraySkill === null || skills === '' ? (
                <AdxEmptyStateV2 />
              ) : (
                arraySkill?.map((item) => <Skills key={item} word={item} />)
              )}
            </Box>
          </Box>
          {videoDialogHandle.isOpen ? <VideoModal /> : null}
        </Box>
        <EditDetailsModal
          error={updateError}
          editDetails={editDetails}
          talentId={candidate_id}
          defaultValues={defaultValues}
          open={open}
          talentDetails={talentDetails}
          setTalentDetails={setTalentDetails}
          handleToggle={handleToggle}
        />
      </>
    )
  }
}
export default PersonalDrawer
